import React from "react";
import { Modal } from "reactstrap";

const ConfirmationModal = ({ isOpen, setOpen, title, message, shortMessage, confirm, buttonText }) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={() => {
                setOpen(false);
            }}
            backdrop={"static"}
            id="staticBackdrop"
        >
            <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                    {title}
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                        setOpen(false);
                    }}
                    aria-label="Close"
                ></button>
            </div>
            <div className="modal-body">
                <div className="alert alert-warning d-flex align-items-center" role="alert">
                    <span role="img" aria-label="bell" className="me-2">🔔</span>
                    {message}
                </div>
                <div className="alert alert-info d-flex align-items-center" role="alert">
                    <span role="img" aria-label="mail" className="me-2">📩</span>
                    {shortMessage}
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => {
                        setOpen(false);
                    }}
                >
                    Close
                </button>
                <button type="button" className="btn btn-primary" onClick={confirm}>
                    {buttonText}
                </button>
            </div>
        </Modal>
    );
}


export default ConfirmationModal;